import styled from 'styled-components';

export const SidebarContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 40px;
  max-width: 207px;
  max-height: fit-content;
  border-left: 1px solid var(--border-soft);
`;
